import { get, put, post } from '../utils/api';

/**
 * 订单服务
 */
export const orderService = {
  // 获取订单列表
  getOrderList: async (page = 1, size = 10, keyword = '', status = null) => {
    const params = { page, size, keyword };
    if (status !== null) params.status = status;
    const response = await get('/orders', params);
    return response.data;
  },

  // 获取用户订单
  getUserOrders: async (walletAddress, page = 1, size = 10) => {
    const response = await get(`/orders/user/${walletAddress}`, { page, size });
    return response.data;
  },

  // 获取订单详情
  getOrderById: async (id) => {
    const response = await get(`/orders/${id}`);
    return response.data;
  },

  // 创建订单（购买产品）
  createOrder: async (walletAddress, productId, amount) => {
    const response = await post('/orders', {
      walletAddress,
      productId,
      amount,
    });
    return response.data;
  },
};

